// Stimulus controller manifest. Registered explicitly (esbuild bundling).
import { application } from "./application"

import RevealController from "./reveal_controller"
import ThemeController from "./theme_controller"
import NavController from "./nav_controller"
import RootSystemController from "./root_system_controller"
import SortableController from "./sortable_controller"
import IntroController from "./intro_controller"

application.register("reveal", RevealController)
application.register("theme", ThemeController)
application.register("nav", NavController)
application.register("root-system", RootSystemController)
application.register("sortable", SortableController)
application.register("intro", IntroController)
